import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 7a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M16 17a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-2"}]]

const IconDotsDiagonal2 = createReactComponent('outline', 'dots-diagonal-2', 'DotsDiagonal2', __iconNode);

export default IconDotsDiagonal2;